// extracted by mini-css-extract-plugin
module.exports = {"conflict":"ConflictIcon_conflict__2nTGT","tooltip":"ConflictIcon_tooltip__eBIiV","clickable":"ConflictIcon_clickable__3xch5"};